// Copyright 2026 The Chromium Authors
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.

import * as i18n from '../../core/i18n/i18n.js';
import * as UI from '../../ui/legacy/legacy.js';

import type * as Targets from './targets.js';

const UIStrings = {
  /**
   * @description Title of the Targets tool.
   */
  targets: 'Targets',
  /**
   * @description Command for showing the Targets tool.
   */
  showTargets: 'Show Targets',
} as const;
const str_ = i18n.i18n.registerUIStrings('panels/targets/targets-meta.ts', UIStrings);
const i18nLazyString = i18n.i18n.getLazilyComputedLocalizedString.bind(undefined, str_);

let loadedTargetsModule: (typeof Targets|undefined);

async function loadTargetsModule(): Promise<typeof Targets> {
  if (!loadedTargetsModule) {
    loadedTargetsModule = await import('./targets.js');
  }
  return loadedTargetsModule;
}

UI.ViewManager.registerViewExtension({
  location: UI.ViewManager.ViewLocationValues.DRAWER_VIEW,
  id: 'targets',
  title: i18nLazyString(UIStrings.targets),
  commandPrompt: i18nLazyString(UIStrings.showTargets),
  persistence: UI.ViewManager.ViewPersistence.CLOSEABLE,
  order: 5,
  async loadView() {
    const Targets = await loadTargetsModule();
    return new Targets.TargetsPanel.TargetsPanel();
  },
});
